import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'response-modal',
  templateUrl: './response-modal-themes.component.html',
  styleUrls: ['./response-modal-themes.component.scss']
})
export class ResponseModalThemesComponent {


  @Input() status: string;

  @Input() header: string;

  @Input() primaryText: string;
  @Input() secondaryText: string;

  constructor(private dialogRef: NbDialogRef<ResponseModalThemesComponent>) {

  }
  close() {
    this.dialogRef.close();
  }
}
